/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {http} from 'hiya-common/src/utils/axios'

import {StageTaskStatusEnum} from '~/pages/ToyBricks/serve'

import {
  bet_rank_item,
  country_item,
  invite_history,
  lottery_history,
  lottery_info,
  lottery_record,
  PageTypeEnum,
  QuizTypeEnum,
} from './interface'
// 世界杯押注信息页面  http://wiki.xunlei.cn/pages/viewpage.action?pageId=100407640
export const world_cup_bet_info = createAsyncThunk(
  'world_cup_bet_info',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'coins' | 'countrys' | 'if_win' | 'win_country' | 'win_coins'
        >
      >
    >('/live/activity/world_cup_bet_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const world_cup_bet_pool = createAsyncThunk(
  'world_cup_bet_pool',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'coins' | 'countrys' | 'if_win' | 'win_country' | 'win_coins'
        >
      >
    >('/live/activity/world_cup_bet_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 世界杯押注  http://wiki.xunlei.cn/pages/viewpage.action?pageId=100407642
export const world_cup_bet = createAsyncThunk(
  'world_cup_bet',
  async (arg: {id: number; coins: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<// 0 成功 1已结束 2金额不足 3金额必须大于50
      {status: number; err_msg: string}>
    >('/live/activity/world_cup_bet', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 世界杯押注榜单 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100407644
export const world_cup_bet_rank = createAsyncThunk(
  'world_cup_bet_rank',
  async (arg: {type: QuizTypeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'list'>>>(
      '/live/activity/world_cup_bet_rank',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 世界杯邀请 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100407899
export const world_cup_invite = createAsyncThunk(
  'world_cup_invite',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'url'>>>(
      '/live/activity/world_cup_invite',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// 世界杯邀请抽奖配置 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100407676
export const world_cup_lottery_config = createAsyncThunk(
  'world_cup_lottery_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'lottery_records'
          | 'lottery_infos'
          | 'lottery_historys'
          | 'invite_historys'
          | 'lottery_cnt_max'
          | 'lottery_cnt'
        >
      >
    >('/live/activity/world_cup_lottery_config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 世界杯邀请抽奖 http://wiki.xunlei.cn/pages/viewpage.action?pageId=100407715

export const world_cup_lottery = createAsyncThunk(
  'world_cup_lottery',
  async (arg, store: any) => {
    const resp = await http.post<
      // 1正常，2次数不够
      HiyaRes<{status: 1 | 2 | 3; lottery_info: lottery_info}>
    >('/live/activity/world_cup_lottery', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// 邀请任务
export const world_cup_invite_task = createAsyncThunk(
  'world_cup_invite_task',
  async (arg: {job_system_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'job_list'>>>(
      '/live/commonactivity/get_jobsystem_info',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// 领取任务奖励
export const world_cup_get_invite_reward = createAsyncThunk(
  'world_cup_get_invite_reward',
  async (arg: {job_id: number; job_system_id: number}, store: any) => {
    // 0:成功;1:没有权限领取;2:已经领取过
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'status'>>>(
      '/live/commonactivity/get_job_done_reward',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

interface InitialStateType {
  selCounty?: country_item
  coins?: number
  countrys?: country_item[]
  if_win?: boolean
  win_country?: country_item
  //  自己	结束赢的金币
  win_coins?: number
  list?: bet_rank_item[]
  in_list?: bet_rank_item[]
  out_list?: bet_rank_item[]
  pageTabIndex: PageTypeEnum
  // 世界杯的邀请链接
  url?: string
  lottery_records?: lottery_record[]
  lottery_infos?: lottery_info[]
  lottery_historys?: lottery_history[]
  invite_historys?: invite_history[]
  lottery_cnt_max?: number
  lottery_cnt?: number
  job_list?: {
    job_id: number
    job_name: string
    job_icon: string
    job_status: StageTaskStatusEnum
    reward_list: string[]
  }[]
  // 0:成功;1:没有权限领取;2:已经领取过
  status?: 0 | 1 | 2
}

const initialState: InitialStateType = {
  pageTabIndex: PageTypeEnum.Task,
}

export const WorldCup2022Slice = createSlice({
  name: 'WorldCup2022',
  initialState,
  reducers: {
    setPageTabIndex: (state, action: PayloadAction<PageTypeEnum>) => {
      Object.assign(state, {
        pageTabIndex: action.payload,
      })
    },
    setSelCounty: (state, action: PayloadAction<country_item>) => {
      Object.assign(state, {
        selCounty: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    // 世界杯押注主页
    builder.addCase(world_cup_bet_info.fulfilled, (state, action) => {
      const {in_list} = state
      Object.assign(state, {
        ...action.payload,
        selCounty: in_list?.length && in_list[0] ? in_list[0] : null,
      })
    })
    // 更新押注的奖池
    builder.addCase(world_cup_bet_pool.fulfilled, (state, action) => {
      const {selCounty} = state
      const {countrys} = action.payload
      // 下注后除了更新奖池还需要更新一下选中的国家的赔率什么的
      // 赔率是通过总奖池计算出来的
      const item = countrys?.find((c) => c.id === selCounty.id)
      Object.assign(state, {
        ...action.payload,
        selCounty: item || selCounty,
      })
    })

    builder.addCase(world_cup_bet_rank.fulfilled, (state, action) => {
      const {type} = action.meta.arg
      const {list} = action.payload
      if (type === QuizTypeEnum.in) {
        Object.assign(state, {in_list: list})
      }
      if (type === QuizTypeEnum.out) {
        Object.assign(state, {out_list: list})
      }
    })

    builder.addCase(world_cup_invite.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(world_cup_lottery_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(world_cup_invite_task.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default WorldCup2022Slice.reducer
export const WorldCup2022Actions = WorldCup2022Slice.actions
